// Preserve user-defined card / item order across saves and Convex reloads.

export const sortByOrder = (items = []) =>
  [...items].sort((a, b) => {
    const ao = a.order ?? Number.MAX_SAFE_INTEGER;
    const bo = b.order ?? Number.MAX_SAFE_INTEGER;
    if (ao !== bo) return ao - bo;
    return (a.id ?? 0) - (b.id ?? 0);
  });

export const withSequentialOrder = (items = []) =>
  items.map((item, index) => ({ ...item, order: index }));
